import React, { Component } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'

class Success extends Component {
    constructor(props) {
        super(props);
        this.state = {
            donelogin: false
        }
    }
    componentDidMount() {
        this.verify()
    }
    verify(){
        const body= {
            "user_id":new URLSearchParams(this.props.location.search).get("userid")
        }
        Axios.post(`${BASE}send_mail/send_mail`,body,{
            headers:{"Content-Type": "application/json"}
        })
        .then(data=>{
            console.log("verify response",data.data)
            this.login(localStorage.getItem("username"), localStorage.getItem("userpass"))
        })
        .catch(err=>{
            console.log("verify error",err.message)
        })
    }
    login(name, pwd) {
        this.setState({
            load: true
        })

        let details = {
            grant_type: "password",
            client_id: "ab15755c-47f7-4699-b306-75f6a58c00b7",
            client_secret: "default",
            username: name,
            password: pwd
        }
        let url = window.location.href;
        let url_string = url;
        let urlStr = new URL(url_string);
        let redir = urlStr.searchParams.get("redir");
        let formBody = [];
        for (let property in details) {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(details[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        Axios({
            url: BASE + "oauth/token",
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formBody
        })
            .then((data) => {
                if (data.data.access_token) {
                    Axios({
                        url: BASE + "jsonapi/user/user/?filter[name][condition][path]=name&filter[name][condition][value]=" + name,
                        method: "GET",
                        headers: {
                            'Authorization': "Bearer " + data.data.access_token
                        },
                    })
                        .then((da) => {
                            if (da.data.data.length > 0) {
                                    console.log(data.data, "expi")
                                    localStorage.setItem('token', data.data.access_token)
                                    localStorage.setItem("uid", da.data.data[0].id)
                                    let s = new Date();
                                    s.setSeconds(s.getSeconds() + data.data.expires_in);
                                    s.setMinutes(s.getMinutes() + 2000);
                                    console.log('gettime', s)
                                    localStorage.setItem('expiryref', s)
                                    localStorage.setItem('expirytime', s);
                                    this.setState({donelogin:true})
                                    localStorage.removeItem("username")
                                    localStorage.removeItem("userpass")
                            }
                            else
                             {}
                        })
                }

            })
            .catch((err) => {
            })
    }

    render() {
        return (
            <div className="successpage">
                <Header />
                <div className="listing" >
                    <div className="main-content">
                        <div className="container">
                            <div className='img-circle'>
                                <img className="success-img" src={process.env.PUBLIC_URL + '/signup/success.png'} />
                            </div>
                            <div className='head'>
                                Success
                            </div>
                            <p className="details">
                                Your email verification is completed and your account is active on I-BIR.
                            </p>
                            {this.state.donelogin?<Link to="/profile" className='pointer view-prof'>
                                View profile
                            </Link>:""}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Success;